import { render } from "./SummaryReport.vue?vue&type=template&id=06873eda&scoped=true"
import script from "./SummaryReport.vue?vue&type=script&lang=js"
export * from "./SummaryReport.vue?vue&type=script&lang=js"

import "./SummaryReport.vue?vue&type=style&index=0&id=06873eda&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06873eda"]])

export default __exports__